import React from 'react'
import { FormattedMessage } from 'react-intl'
import cx from 'classnames'
import moment from 'moment'
import _ from 'lodash'

import { LOCALE_PREFIX } from '../../constants'

export default function NegativeInformation({ data }) {
    let showTitle = false
    if (_.some(data, (val) => val?.active || val?.historical)) {
        showTitle = true
    }

    return (
        <>
            {showTitle && (
                <>
                    <div className={'block-separator'} />
                    <div className={'row title'}>
                        <FormattedMessage id={`${LOCALE_PREFIX}.negativeEvents`} />
                    </div>
                    <div className={'block-separator'} />
                </>
            )}
            {_.map(Object.keys(data), (key, index) => {
                const active = data?.[key]?.active
                const historical = data?.[key]?.historical
                const startDate = data?.[key]?.startDate

                if (!active && !historical) return null

                return (
                    <div className={'row'} key={`negative-events-row-${index}`}>
                        <div
                            className={cx('negative-icon', `type-${key}${!active && historical ? '-historical' : ''}`)}
                        />
                        <FormattedMessage id={`${LOCALE_PREFIX}.${key}${!active && historical ? '.historical' : ''}`} />
                        {startDate && (
                            <span style={{ paddingLeft: '4px' }}>
                                <FormattedMessage
                                    id={`${LOCALE_PREFIX}.fromDate`}
                                    values={{ date: moment(startDate).format('DD.MM.YYYY') }}
                                />
                            </span>
                        )}
                    </div>
                )
            })}
        </>
    )
}
